import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, ReplaySubject, Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

import { checkoutTypes } from 'src/app/shared/constants/bookingSteps.constant';

import { UserDetailsData, UserProfile } from 'src/app/shared/models/user.model';

import { environment } from 'src/environments/environment';

export interface UserLocation {
  city: string,
  countryCode: string,
  countryName: string,
  coordinates: {
    latitude: number,
    longitude: number,
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public hasOtpCodeExpired = new BehaviorSubject<boolean>(false);

  public authData: UserDetailsData;
  public location: any;
  public userProfile: UserProfile;

  private otpTimeoutSubscription: Subscription;

  private userLocationSubject$: ReplaySubject<UserLocation> = new ReplaySubject(1);

  public userLocation$: Observable<UserLocation> = this.userLocationSubject$
    .asObservable()
    .pipe(
      take(1),
    )

  constructor(
    public analyticsService: AnalyticsService,
    private http: HttpClient,
  ) {}

  public invalidateOtpTimeout(): void {
    this.hasOtpCodeExpired.next(false);

    if (this.otpTimeoutSubscription) {
      this.otpTimeoutSubscription.unsubscribe();
    }
  }

  getUserData(checkoutType: checkoutTypes): {
    isExistingUser: boolean;
    isNewUser: boolean;
    isGuest: boolean;
} {
    return {
      isExistingUser: checkoutType === checkoutTypes.checkoutDetails,
      isNewUser: checkoutType === checkoutTypes.createAccount,
      isGuest: checkoutType === checkoutTypes.guestCheckout,
    };
  }

  updateLocation(): Observable<UserLocation> {
    const ipaddress = ''; // We can change it to test
    return this.http.get(`${environment.apiUrl}GeoLocation/user-location?ip=${ipaddress}`)
      .pipe(
        tap((location: UserLocation) => {
          this.location = location;
          this.userLocationSubject$.next(location);
        })
      );
  }

}
